function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "210",
  height: "37",
  viewBox: "0 0 210 37",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M14.49 1.517v-.01c-.095-.255-.354-.374-.573-.264l-4.09 2.045a.523.523 0 00-.235.283c-.087.265.023.557.25.667.103.045.22.045.338-.01l4.082-2.045c.228-.11.33-.41.228-.666zM9.56 11.57L7.598 9.625l-1.319.648c-.267.128-.565-.01-.675-.32-.11-.3.016-.648.275-.776l.856-.42-1.374-1.36-1.429 1.169-1.467 1.187a4.256 4.256 0 00-.777.867c-.236.365-.4.74-.51 1.096-.103.32-.15.612-.158.858 0 .146.016.329.063.402.047.091.196.192.416.301.26.137.597.247.973.329.471.091 1.029.137 1.594.082a4.644 4.644 0 001.436-.356A567.242 567.242 0 009.56 11.57zm1.327-.247c.29.283.22.85-.15 1.005-1.624.712-3.249 1.415-4.874 2.118a5.403 5.403 0 01-1.719.43 6.066 6.066 0 01-1.844-.101 4.511 4.511 0 01-1.209-.402c-.392-.201-.69-.448-.856-.721C.11 13.396 0 13.112 0 12.547c.008-.375.078-.804.212-1.224.141-.466.361-.959.667-1.424a4.903 4.903 0 011.005-1.114c1.067-.877 2.143-1.753 3.21-2.63a.454.454 0 01.628.037l1.452 1.442v-2.73c0-.237.126-.447.314-.548l1.052-.52a2.076 2.076 0 01.102-.703c.141-.411.416-.75.785-.94L13.61.1c.73-.31 1.523.119 1.821.94.322.859-.023 1.873-.761 2.238l-4.09 2.045a1.26 1.26 0 01-1.114.018 1.455 1.455 0 01-.526-.41l-.738.365v3.35l2.685 2.676z",
  id: "path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "beta-copy-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(2 6)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M192.146 12.761L199.725 26H6a7 7 0 01-7-7V6a7 7 0 017-7h193.688l-7.542 13.761z",
  id: "Rectangle-6",
  stroke: "#FFF",
  strokeWidth: "2",
  fill: "#910155"
}), /*#__PURE__*/React.createElement("text", {
  id: "Daten-in-Aufbereitun",
  fontFamily: "OpenSans-Bold, Open Sans",
  fontSize: "14",
  fontWeight: "bold",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("tspan", {
  x: "27",
  y: "17"
}, "Daten in Aufbereitung!")), /*#__PURE__*/React.createElement("g", {
  id: "icon/phase/bau",
  transform: "translate(6 4)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_1547539_cc",
  transform: "translate(0 .648)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#1A1A1A",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "color/white",
  mask: "url(#mask-2)",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h15.916v17.905H0z",
  transform: "matrix(-1 0 0 1 15.552 -1.355)",
  id: "Rectangle"
})))))))));